// extracted by mini-css-extract-plugin
export default {"root":"root-jCWfAH","img":"img-WczoP6","content":"content-eCDcQe","notFountImg":"notFountImg-mmoFXT"};